"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useInitializeMap = exports.useInitializeCommunication = exports.useCheckForExistingScript = exports.useCheckForExistingHarpScript = void 0;
var _react = _interopRequireWildcard(require("react"));
var MapConstants = _interopRequireWildcard(require("../constants"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
// initialize communication with back-end when API script(s) have loaded
// this step is required before a Map object can be created and modified
var useInitializeCommunication = function useInitializeCommunication(scriptLoaded) {
  var _useState = (0, _react.useState)({
      platform: null,
      platformError: null
    }),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  (0, _react.useEffect)(function () {
    if (!state.platform && scriptLoaded) {
      if (!window.H) {
        // if there is no global H now, there was an error.
        setState({
          platform: null,
          platformError: "Error! window.H is missing."
        });
      } else {
        var platform =
        // initialize service communications with api key
        new window.H.service.Platform({
          'apikey': MapConstants.API_KEY
        });
        setState({
          platform: platform,
          platformError: null
        });
      }
    }
  }, [state.platform, scriptLoaded]);
  return [state.platform, state.platformError];
};

// Handle initializing the map after the pre-reqs have loaded and backend communication is established
// This step will allow the initial map render and handles: polygons, markers, and other layers prior to User interaction
exports.useInitializeCommunication = useInitializeCommunication;
var useInitializeMap = function useInitializeMap(platform, showUI, customControls, mapConfig, scheme) {
  var _useState3 = (0, _react.useState)({
      map: null,
      ui: null,
      behavior: null,
      mapError: null
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    state = _useState4[0],
    setState = _useState4[1];
  (0, _react.useEffect)(function () {
    if (!state.map && platform) {
      var _H = window.H; // brevity
      var mapContainer = document.getElementById(MapConstants.MAP_CONTAINER_ID); // container element

      if (!_H || !platform) {
        // if there is no global H or no platform in state, there has been an error
        setState(_objectSpread(_objectSpread({}, state), {}, {
          map: null,
          mapError: "Error: window.H missing or platform null"
        }));
        return;
      } else if (_H && platform && mapContainer && !state.map) {
        var defaultLayers = platform.createDefaultLayers({
          engineType: _H.Map.EngineType.HARP
        }); // get default layers

        var theme = scheme !== null && scheme !== void 0 && scheme.includes("vector") ? defaultLayers.vector.normal.mapnight : defaultLayers.raster.normal.mapnight;
        if (scheme !== null && scheme !== void 0 && scheme.includes("normal")) {
          if (scheme !== null && scheme !== void 0 && scheme.includes("night")) theme = scheme !== null && scheme !== void 0 && scheme.includes("vector") ? defaultLayers.vector.normal.mapnight : defaultLayers.raster.normal.mapnight;else theme = scheme !== null && scheme !== void 0 && scheme.includes("vector") ? defaultLayers.vector.normal.map : defaultLayers.raster.normal.map;
        } else if (scheme !== null && scheme !== void 0 && scheme.includes("satellite")) {
          theme = defaultLayers.raster.satellite.map;
        } else if (scheme !== null && scheme !== void 0 && scheme.includes("terrain")) {
          theme = defaultLayers.raster.terrain.map;
        } else {
          theme = scheme !== null && scheme !== void 0 && scheme.includes("vector") ? defaultLayers.vector.normal.map : defaultLayers.raster.normal.map;
        }
        var map =
        // create new MAP
        new _H.Map(mapContainer, theme, {
          engineType: _H.Map.EngineType.HARP,
          center: mapConfig !== null && mapConfig !== void 0 && mapConfig.center ? mapConfig.center : MapConstants.MAP_CENTER,
          zoom: "".concat(mapConfig !== null && mapConfig !== void 0 && mapConfig.zoom ? mapConfig.zoom : MapConstants.MAP_ZOOM)
        });
        var mapEvents = new _H.mapevents.MapEvents(map);

        /* Uncomment this section to get console.log debug info on User interaction with map
        map.addEventListener('tap', function(evt) {
            // Log 'tap' and 'mouse' events:
            console.log(evt.type, (evt as any).currentPointer.type);
        });
        */

        var behavior = new _H.mapevents.Behavior(mapEvents);

        // UI generation
        var _ui = showUI ? _H.ui.UI.createDefault(map, defaultLayers) : null;

        // Add any provided custom buttons to the UI
        // note that custom controls are styled via classnames and 
        // the associated css is imported to HereMap.tsx
        customControls && customControls.map(function (control, mapIndex) {
          if (control) {
            var newControl = MapConstants.buildCustomControl(control);
            if (newControl) _ui === null || _ui === void 0 ? void 0 : _ui.addControl("custom-control-".concat(mapIndex), newControl);
          }
          return null;
        });
        setState(_objectSpread(_objectSpread({}, state), {}, {
          map: map,
          ui: _ui,
          behavior: behavior
        }));
      }
    }
  }, [state, platform, showUI, customControls, mapConfig]);
  return state;
};

// This effect runs once to check if the Here maps script has 
// already loaded. This was added to ensure that in cases where 
// the script was loaded by a previously disposed HereMap component,
// a new map will still initialize properly 
exports.useInitializeMap = useInitializeMap;
var useCheckForExistingScript = function useCheckForExistingScript(callback) {
  _react.default.useEffect(function () {
    if (window.H) {
      callback();
    }
  }, []);
};
exports.useCheckForExistingScript = useCheckForExistingScript;
var useCheckForExistingHarpScript = function useCheckForExistingHarpScript(src, callback) {
  _react.default.useEffect(function () {
    var pageScripts = document.getElementsByTagName("script");
    for (var i = 0; i < pageScripts.length; i++) {
      if (pageScripts[i].src === src) callback();
    }
  }, []);
};
exports.useCheckForExistingHarpScript = useCheckForExistingHarpScript;